export const PREVIEW_IFRAME_ID = "onsiteEditsPreview";

export const VARIATION_BUTTON_MIN_WIDTH = 60;
export const VARIATION_BUTTON_MAX_WIDTH = 120;
